import { render, staticRenderFns } from "./milestone-form-footer-save-as-draft-button.vue?vue&type=template&id=589fd890&scoped=true&"
import script from "./milestone-form-footer-save-as-draft-button.vue?vue&type=script&lang=ts&"
export * from "./milestone-form-footer-save-as-draft-button.vue?vue&type=script&lang=ts&"
import style0 from "./milestone-form-footer-save-as-draft-button.vue?vue&type=style&index=0&id=589fd890&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589fd890",
  null
  
)

export default component.exports